import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import {
  usePlaybackIsPlaying,
  usePlaybackIsSeeking,
  usePlaybackPause,
  usePlaybackPlay,
} from '@app/core/playback/hooks/usePlayback';
import { PlayLiveBtn } from './PlayLiveBtn';

export function PlayLive() {
  const capture = usePostHogCapture();
  const isSeeking = usePlaybackIsSeeking();
  const isPlaying = usePlaybackIsPlaying();
  const pause = usePlaybackPause();
  const play = usePlaybackPlay();

  const handleClick = () => {
    capture('logger:play_live_clicked', { action: isPlaying ? 'stop' : 'play' });

    if (isPlaying) {
      pause();
    } else {
      play();
    }
  };

  return <PlayLiveBtn isLoading={isSeeking} isPlaying={isPlaying} onClick={handleClick} />;
}
